import {Store} from "@ngrx/store";

interface AppState {
  physicianSession: UserSession
}

export const selectUserSession = (store: Store<any>) => {
  return store.select((state) => <UserSession>state.userSession)
};




// WEBPACK FOOTER //
// ./src/app/shared/selectors/index.ts